export const CLARITY_CONSENT_KEY = 'gts_analytics_consent';
let loaded = false;

export function isClarityConfigured() {
  return process.env.REACT_APP_CLARITY_ENABLED === 'true'
    && Boolean(process.env.REACT_APP_CLARITY_PROJECT_ID);
}

export function isClarityEnabled() {
  const trackingEnvironment = process.env.NODE_ENV === 'production'
    || (process.env.NODE_ENV === 'development'
      && process.env.REACT_APP_CLARITY_TRACK_LOCAL === 'true');
  return trackingEnvironment && isClarityConfigured();
}

export function startClarity() {
  if (loaded || !isClarityEnabled()) return;
  try {
    if (window.localStorage.getItem(CLARITY_CONSENT_KEY) !== 'accepted') return;
  } catch {
    // Analytics must not interfere with the portal when storage is unavailable.
    return;
  }

  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  loaded = true;
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
  document.head.appendChild(script);

  window.clarity('consentv2', {
    ad_Storage: 'denied',
    analytics_Storage: 'granted',
  });
}

export function stopClarityAfterWithdrawal() {
  if (typeof window.clarity === 'function') {
    window.clarity('consentv2', {
      ad_Storage: 'denied',
      analytics_Storage: 'denied',
    });
  }

  // Reload without the tracking script after the caller stores the decline.
  window.location.reload();
}
